import { useState } from "react";
import { LoginForm } from "../../lib/actions";
import { useNavigate } from "react-router-dom";

export default function LoginUi({ token }) {
    const nav = useNavigate();
    const [loading, setLoading] = useState(false);
    

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const formData = new FormData(e.target);
        formData.append("device_token", token);
        
        try {
            const result = await LoginForm(formData);
            if(result){
                nav("/");
            };
        } catch (error) {
            console.error("Login failed", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-6">
            {/* Email Field */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
                <input
                    type="email"
                    name="email"
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 text-black rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all outline-none"
                    placeholder="admin@wasly.net"
                    required
                />
            </div>

            {/* Password Field */}
            <div>
                <div className="flex justify-between mb-2">
                    <label className="block text-sm font-medium text-gray-700">Password</label>
                </div>
                <input
                    type="password"
                    name="password"
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 text-black rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all outline-none"
                    placeholder="••••••••"
                    required
                />
            </div>

            {/* Submit Button */}
            <button
                disabled={loading}
                type="submit"
                className="w-full bg-[#02182D] hover:bg-[#032a4e] text-white font-bold py-3 px-4 rounded-xl transition-all transform active:scale-[0.98] flex justify-center items-center shadow-lg shadow-blue-900/20"
            >
                {loading ? (
                   "Loading ..."
                ) : (
                    "Sign In to Dashboard"
                )}
            </button>
        </form>
    );
}